const ADMIN_EMAIL = "info@saficuts.de";

// E-Mail-Funktion über Vercel API mit Template-Support
const sendEmailNotification = async (subject, message, template = null, data = null) => {
  try {
    const body = {
      to: ADMIN_EMAIL,
      subject: subject,
    };

    if (template && data) {
      body.template = template;
      body.data = data;
    } else {
      body.message = message;
    }

    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log(`📧 E-Mail erfolgreich gesendet an ${ADMIN_EMAIL}:`, subject);
      return { success: true };
    } else {
      console.error('Fehler beim Senden der E-Mail:', responseData.error);
      return { success: false, error: responseData.error };
    }
  } catch (error) {
    console.error("Fehler beim Senden der E-Mail:", error);
    return { success: false, error: error.message };
  }
};

// Funktion für E-Mails an spezifische Empfänger mit Template-Support
const sendEmailToRecipient = async (toEmail, subject, message, template = null, data = null) => {
  try {
    const body = {
      to: toEmail,
      subject: subject,
    };

    if (template && data) {
      body.template = template;
      body.data = data;
    } else {
      body.message = message;
    }

    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log(`📧 E-Mail erfolgreich gesendet an ${toEmail}:`, subject);
      return { success: true };
    } else {
      console.error('Fehler beim Senden der E-Mail:', responseData.error);
      return { success: false, error: responseData.error };
    }
  } catch (error) {
    console.error("Fehler beim Senden der E-Mail:", error);
    return { success: false, error: error.message };
  }
};

// Benachrichtigung an Kunden bei Terminänderung
const sendNotificationEmail = async (toEmail, oldAppointment, newAppointment) => {
  const subject = "🔄 Änderung deines Termins - SafiCuts";
  
  // Mit Template senden
  return await sendEmailToRecipient(
    toEmail, 
    subject, 
    null, 
    'admin-update',
    {
      customerName: newAppointment.name || 'Kunde',
      appointmentDate: new Date(newAppointment.date).toLocaleDateString("de-DE"),
      appointmentTime: newAppointment.time,
      service: newAppointment.service,
      oldAppointmentDate: new Date(oldAppointment.date).toLocaleDateString("de-DE"),
      oldAppointmentTime: oldAppointment.time,
      oldService: oldAppointment.service,
    }
  );
};

// Benachrichtigung an Admin bei neuem Termin
const sendAdminNotificationNewAppointment = async (appointment, customerName) => {
  const subject = "🆕 Neuer Termin vereinbart - SafiCuts";
  
  console.log("📧 Admin-Benachrichtigung für neuen Termin");
  
  return await sendEmailNotification(
    subject, 
    null, 
    'admin-new',
    {
      customerName: customerName,
      appointmentDate: new Date(appointment.date).toLocaleDateString("de-DE"),
      appointmentTime: appointment.time,
      service: appointment.service,
    }
  );
};

// Benachrichtigung an Admin bei Terminänderung
const sendAdminNotificationAppointmentUpdate = async (oldAppointment, newAppointment, customerName) => {
  const subject = "🔄 Termin wurde geändert - SafiCuts";
  
  console.log("📧 Admin-Benachrichtigung für Terminänderung");
  
  return await sendEmailNotification(
    subject, 
    null, 
    'admin-update',
    {
      customerName: customerName,
      appointmentDate: new Date(newAppointment.date).toLocaleDateString("de-DE"),
      appointmentTime: newAppointment.time,
      service: newAppointment.service,
      oldAppointmentDate: new Date(oldAppointment.date).toLocaleDateString("de-DE"),
      oldAppointmentTime: oldAppointment.time,
      oldService: oldAppointment.service,
    }
  );
};

// Benachrichtigung an Admin bei Terminlöschung
const sendAdminNotificationAppointmentDeleted = async (appointment, customerName) => {
  const subject = "🗑️ Termin wurde gelöscht - SafiCuts";
  
  console.log("📧 Admin-Benachrichtigung für Terminlöschung");
  
  return await sendEmailNotification(
    subject, 
    null, 
    'admin-delete',
    {
      customerName: customerName,
      appointmentDate: new Date(appointment.date).toLocaleDateString("de-DE"),
      appointmentTime: appointment.time,
      service: appointment.service,
    }
  );
};

// Bestätigungs-E-Mail an Kunden bei neuer Buchung
const sendConfirmationEmail = async (toEmail, appointment, customerName) => {
  const subject = "✅ Termin bestätigt - SafiCuts";
  
  console.log("📧 Bestätigungs-E-Mail an Kunden");
  
  return await sendEmailToRecipient(
    toEmail,
    subject,
    null,
    'confirmation',
    {
      customerName: customerName,
      appointmentDate: new Date(appointment.date).toLocaleDateString("de-DE"),
      appointmentTime: appointment.time,
      service: appointment.service,
    }
  );
};

// Stornierung-E-Mail an Kunden
const sendCancellationEmail = async (toEmail, appointment, customerName, cancelledByAdmin = false) => {
  const subject = "❌ Termin storniert - SafiCuts";
  
  console.log("📧 Stornierung-E-Mail an Kunden", cancelledByAdmin ? "(vom Admin)" : "(selbst storniert)");
  
  return await sendEmailToRecipient(
    toEmail,
    subject,
    null,
    'cancellation',
    {
      customerName: customerName,
      appointmentDate: new Date(appointment.date).toLocaleDateString("de-DE"),
      appointmentTime: appointment.time,
      service: appointment.service,
      cancelledByAdmin: cancelledByAdmin,
    }
  );
};

export default sendNotificationEmail;
export {
  sendAdminNotificationNewAppointment,
  sendAdminNotificationAppointmentUpdate,
  sendAdminNotificationAppointmentDeleted,
  sendConfirmationEmail,
  sendCancellationEmail,
  sendEmailToRecipient,
};
